import React from "react";

import { Alert } from "reactstrap";

import "./Alerts.css";

const Alerts = (props) => {
  const onDismissAlert = (a) => {
    props.setAlerts(props.alerts.filter((item) => item.id !== a.id));
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "90%",
        maxWidth: "600px",
        zIndex: 9999,
        pointerEvents: "auto",
      }}
    >
      {props.alerts
        .filter((alert) => alert.alertType === props.alertType)
        .map((alert, index) => (
          <Alert
            key={index}
            color={alert.color}
            toggle={() => onDismissAlert(alert)}
            className="brand-alert"
          >
            {alert.message}
          </Alert>
        ))}
    </div>
  );
};

export default Alerts;
